
import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    CanLoad,
    Route
} from '@angular/router';

import {AuthHelper} from './common/auth.helper'
import { PermissionService } from './shared/services/permission.service';
import { BaseService } from './shared/services/base.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    public landingRedirect: string = '/landing';
    constructor(private router: Router,
                private permissionService: PermissionService,
                private baseService: BaseService) {
    }

    // Not using but worth knowing about
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (AuthHelper.isLoggedIn(state.url)) {
           // this.router.navigate(['/request-appointment']);
            return true;
        }
        //this.router.navigate([this.landingRedirect]);
        this.baseService.logout();
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (AuthHelper.isLoggedIn(state.url)) {
            if (this.permissionService.hasPermissionOnUrl(state.url)) {
                return true;
            }
        }
        //this.router.navigate([this.landingRedirect]);
        this.baseService.logout();
        return false;
    }

    canLoad(route: Route): boolean {
        const url = `/${route.path}`;
        if (AuthHelper.isLoggedIn(url)) {
            return true;
        }
        //this.router.navigate([this.landingRedirect]);
        this.baseService.logout();
        return false;
    }

}

export const authProviders = [AuthGuard, AuthHelper];



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/auth.guard.ts